import * as React from "react";

import Congrats from "./Congrats";
import Benefits from "./Benefits";
import Footer from "./Footer";
import Modal from "./Modal";
import "./Success.css";

interface SuccessProps {
  formComponent: JSX.Element;
  isShowingModal: boolean;
  handleModalClose: () => void;
}

const Success = (props: SuccessProps) => (
  <div className="order-success">
    <div className="order-success__main-container container">
      <Modal
        isOpen={props.isShowingModal}
        handleClose={props.handleModalClose}
      />
      <div className="row">
        <div className="col-md-5">
          <Congrats />
        </div>
        <div className="col-md-7">
          <section className="order-success-signup success-green">
            <div className="order-success-signup__head">
              <h1>Điện thoại của bạn đâu rồi?</h1>
            </div>
            <h2 className="order-success-signup__subtitle">
              Chuyên viên tư vấn sẽ gọi điện tư vấn cho bạn trong ít phút nữa
            </h2>
            {props.formComponent}
          </section>
        </div>
      </div>
      <Benefits />
    </div>
    <Footer />
  </div>
);

export default Success;



// WEBPACK FOOTER //
// ./src/routes/OrderSuccess/components/Success.tsx